import { render, staticRenderFns } from "./LimitedsDeposit.vue?vue&type=template&id=1b72b76c&scoped=true"
import script from "./LimitedsDeposit.vue?vue&type=script&lang=js"
export * from "./LimitedsDeposit.vue?vue&type=script&lang=js"
import style0 from "./LimitedsDeposit.vue?vue&type=style&index=0&id=1b72b76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b72b76c",
  null
  
)

export default component.exports